import React, {useState} from 'react';
import { Row, Col } from 'react-bootstrap';
import Main from '../../components/Main';
import RegisterForm from '../../components/RegisterForm';
import RegisterCard from '../../components/RegisterCard';

// Register Subpage of MyAccount Page

const images = {};

function importAll(r) {
  r.keys().forEach((key) => {
    images[key.replace('./', '')] = r(key);
  });
}


// Imports all images from the register_icons folder into the images array

importAll(require.context('../../assets/images/register_icons', false, /\.(png|jpe?g|svg)$/));
 
const Register = () => {
  const [selectedForm, setSelectedForm] = useState(false);
  const handleClickForm = () => setSelectedForm(true);

  const contentItems = [
    {
      icon: images['clients.png'],
      title: 'Clients',
      description: 'Get fast access to specialized teams of professionals for your strategic projects. ',
      buttonText: 'Register',
      link: "/aboutus/clients",
    },
    {
      icon: images['execpartners.png'],
      title: 'Executive Partners',
      description: 'Join our team as an equity holding partner, and offer a full range of professional services to your clients. ',
      buttonText: 'Apply to join',
      link: "/aboutus/execpartners",
    },
    {
      icon: images['consultants.png'],
      title: 'Consultants',
      description: 'Access the best projects at top tier clients to advance your career, maximize revenues and earn equity. ',
      buttonText: 'Apply to join',
      link: "/aboutus/consultants",
    },
    {
      icon: images['iqosystem.png'],
      title: 'IQosystem',
      description: 'Add value on an ad hoc basis, by contributing knowledge, leads or identifying experts. ',
      buttonText: 'Apply to join',
      link: "/aboutus/iqosystem",
    },
  ];

  // if the user has clicked on Register or Apply to join, the form will be displayed 
  if (selectedForm === true) {
    return <Main componentList={[<RegisterForm />]}/>;
  }

  return (
    <div>
      <Main componentList={[
        <div>
          <h6 className='top_sentence'>Select your profile and register today</h6>
          <Row>
            {contentItems.map((item, index) => (
              <Col md={6} key={index} className="mb-3">
                <RegisterCard item={item} handleClickForm={handleClickForm} />
              </Col>
            ))}
          </Row>
        </div>
      ]} />
    </div>
  );
};

export default Register;